import { API_ROUTES } from '@memorai/routes';
import type { Category } from '@memorai/types';
import { apiFetch } from './client.js';

export type { Category } from '@memorai/types';

export async function fetchCategories(): Promise<Category[]> {
    return apiFetch<Category[]>(API_ROUTES.CATEGORIES);
}

export async function createCategory(category: Partial<Category>): Promise<Category> {
    return apiFetch<Category>(API_ROUTES.CATEGORIES, {
        method: 'POST',
        body: JSON.stringify(category),
    });
}

export async function updateCategory(id: string, updates: Partial<Category>): Promise<Category> {
    return apiFetch<Category>(API_ROUTES.CATEGORY(id), {
        method: 'PATCH',
        body: JSON.stringify(updates),
    });
}

export async function deleteCategory(id: string): Promise<void> {
    return apiFetch<void>(API_ROUTES.CATEGORY(id), {
        method: 'DELETE',
    });
}

